import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router";
import AuthHeader from "../../layout/AuthHeader";
import apiRequest from "../../../services/apiRequest";
import AuthenticationService from "../../../services/AuthenticationService";
import Alert from "../../Alert";
import Button from "../../Button";
import Container from "../../Container";
import Input from "../../Input";
import UpdatePassword from "../../forms/UpdatePassword";
import Toggle from "../../Toggle";
import Modal from "../../Modal";
import Gdpr from "./gdpr";

const Registration = () => {
  const { token } = useParams();
  const [uid, setUid] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [flgGdpr, setFlgGdpr] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    apiRequest
      .post("/users/validate", { token: token }, { publicRequest: true })
      .then((data) => {
        setUid(data['id']);
        setEmail(data['email']);
      })
      .catch((err) => {
        console.error("Error:", err);
        setError("Not authorized");
      })
      .finally(() => setLoading(false));
  }, [token]);

  const submit = useCallback(
    async (e) => {
      try {
        e.preventDefault();

        if (!password || !confirmPassword || password !== confirmPassword) {
          return;
        }

        if (!flgGdpr) {
          setError('Il consenso al trattamento dati è obbligatorio')
          return;
        }

        setLoading(true);
        setError("");
        await apiRequest.post(
          "/users/signup",
          { uid: uid, password: password },
          { publicRequest: true }
        );
        try {
          await AuthenticationService.login(email, password);
          window.location = "/preventivi";
        } catch (error) {
          setError("Autenticazione fallita");
        }
      } catch (error) {
        setError("Errore durante il salvataggio");
      } finally {
        setLoading(false);
      }
    },
    [password, uid, email, confirmPassword, flgGdpr]
  );

  return (
    <div className="bg-gray-100 min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <Container>
        <AuthHeader title="Registrazione utente" />

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form action="#" method="POST" onSubmit={submit}>
              <div>
                <Input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  label="Email"
                  type="email"
                  disabled
                />
              </div>

              <UpdatePassword
                password={password}
                setPassword={setPassword}
                confirmPassword={confirmPassword}
                setConfirmPassword={setConfirmPassword}
                showPassword={showPassword}
              />
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-am-600 focus:ring-am-500 border-gray-300 rounded"
                    onChange={(e) => {
                      setShowPassword(e.target.checked);
                    }}
                  />
                  <label
                    htmlFor="remember-me"
                    className="ml-2 block text-sm text-gray-900"
                  >
                    Mostra password
                  </label>
                </div>
              </div>
              <div className="mb-6">
                <span className="text-xs cursor-pointer text-gray-900 underline"
                  onClick={() => setShowPrivacy(true)}>
                  Informativa sulla privacy
                </span>
                <Toggle
                  vertical
                  label="Consenso al trattamento dati personali"
                  checked={flgGdpr}
                  onChange={() => setFlgGdpr(!flgGdpr)}
                />
              </div>
              <div>
                <Button full type="submit" submitting={loading}>
                  Registrati
                </Button>
              </div>
              {error ? (
                <div className="mt-4">
                  <Alert slim type="error" title={error} />
                </div>
              ) : null}
            </form>
          </div>
        </div>
        {showPrivacy ? (
          <Modal onExit={() => setShowPrivacy(false)}>
            <div className="w-full flex-col flex items-center my-6">
              <h3 className=" text-center text-xl font-extrabold text-gray-900">
                Informativa sulla privacy
              </h3>
              <Gdpr />
              <Button onClick={() => setShowPrivacy(false)} >OK</Button>
            </div>
          </Modal>
        ) : null}
      </Container>
    </div>
  );
};

export default Registration;
